
import React from "react";
import { Box } from "@material-ui/core";

export const QuizInlineCardActions = ({ children }) => (
  <Box ml={3}>{children}</Box>
);
